import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import { HomeContent } from "./components/HomeContent.jsx";
import { WorkContent } from "./components/WorkContent.jsx";
import { TestimonialsContent } from "./components/TestimonialsContent.jsx";
import { AboutContent } from "./components/AboutContent.jsx";
import { MusicContent } from "./components/MusicConent.jsx";
import { ConnectContent } from "./components/ConnectContent.jsx";
import { AppHeader } from "./components/common/AppHeader.jsx";

import "./App.css";

function App() {
  return (
    <Router>
      <Helmet>
        <meta name="description" content={process.env.REACT_APP_DESCRIPTION} />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-sand">
        <AppHeader />

        {/* Main content */}
        <main className="flex-grow">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <HomeContent />
                  <AboutContent />
                  <WorkContent />
                  <TestimonialsContent />
                  <MusicContent />
                  <ConnectContent />
                </>
              }
            />

            {/* Redirect unknown paths to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
